import Vue from "vue";
import VueRouter from "vue-router";
import Core from "../views/Core.vue";
import Chat from "../views/Chat.vue";
import Projects from "../views/Projects.vue";
import Login from "../views/Login.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/projects/:id/skills/:skillId",
    name: "Core",
    component: Core,
    meta: { requiresAuth: true }
  },
  {
    path: "/projects/:id/skills",
    name: "Core",
    component: Core,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: "/",
    name: "Home",
    component: Projects,
    meta: { requiresAuth: true }
    // beforeEnter: (to, from, next) => {
    //   const token = localStorage.getItem('authToken');
    //   if (!token) {
    //     next({ name: 'Login' }); // Redirige vers la page login si pas de token
    //   } else {
    //     next(); // Accède à la page si un token est présent
    //   }
    // },
  },
  // {
  //   path: "/history/:id",
  //   name: "History",
  //   component: History,
  // },
  // {
  //   path: "/history/:id/error",
  //   name: "Error",
  //   component: Error,
  // },
  {
    path: "/project/:id/chat",
    name: "Chat",
    component: Chat,
    meta: { requiresAuth: true }
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('authToken');

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({ name: 'Login' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
